import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { SlimLayout } from "../../NextComponents/SlimLayout";
import { Button } from "../../NextComponents/Button";
import { SelectField, TextField } from "../../NextComponents/Fields";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { Link } from "react-router-dom";
import { baseUrl } from "../../../Environments/environment";
import onelyk from "../../../Assets/onelyklogo1.svg";
import countries from "../../../utils/countries";
import { requestHandler } from "../../../utils";
import { apiClient } from "../../../api";
import UserValidationSchema from "../../../utils/userValidation";
import ConditionsModal from "../../Conditions/ConditionsModal";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import ReCaptchaField from "../../Common/ReCaptchaField";


import { useSearchParams } from "react-router-dom";
export default function Register() {
	const [formData, setFormData] = useState({
		firstName: "",
		lastName: "",
		email: "",
		password: "",
		phoneNumber: "",
		referralSource: "", // Add this line
	});
	const dropdownRef = useRef(null);
	const searchInputRef = useRef(null);
	const [selectedCountry, setSelectedCountry] = useState("");
	const [countryCode, setCountryCode] = useState("+1");
	const [searchTerm, setSearchTerm] = useState("");
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const [phoneNumber, setPhoneNumber] = useState(undefined);
	const [otp, setOtp] = useState("");
	const [isRegistering, setIsRegistering] = useState(true);
	const [verified, setVerified] = useState(false);
	const router = useNavigate();
	const [isLoading, setIsLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [resendCountdown, setResendCountdown] = useState(0);
	const [inputErrors, setInputErrors] = useState({});
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalContent, setModalContent] = useState("");
	const [isChecked, setIsChecked] = useState(false);
	const [captchaToken, setCaptchaToken] = useState(null);

	const [searchParams] = useSearchParams();
	const token = searchParams.get("token");
	useEffect(() => {
		let timer;
		if (resendCountdown > 0) {
			timer = setTimeout(() => {
				setResendCountdown(resendCountdown - 1);
			}, 1000);
		}
		return () => clearTimeout(timer);
	}, [resendCountdown]);
	useEffect(() => {
		const handleClickOutside = (event) => {
			// Check if click is outside both the dropdown and the trigger button
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsDropdownOpen(false);
				setSearchTerm("");
			}
		};

		// Only add the event listener if the dropdown is open
		if (isDropdownOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isDropdownOpen]);
	const toggleDropdown = (e) => {
		e.stopPropagation();
		setIsDropdownOpen(!isDropdownOpen);
		if (!isDropdownOpen) {
			// Reset search when opening
			setSearchTerm("");
			// Focus search input after opening
			setTimeout(() => {
				searchInputRef.current?.focus();
			}, 0);
		}
	};
	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});
	};

	const handleOtpChange = (e) => {
		const { value } = e.target;
		setOtp(value);
	};

	const handleRegisterSubmit = async (e) => {
		e.preventDefault();
		if (!captchaToken) {
			setInputErrors({ captcha: "Please verify captcha" });
			return;
		  }
		setIsLoading(true);
		const combinedPhoneNumber = countryCode + phoneNumber;

		// Create a new object with all the form data
		const dataToSend = {
			...formData,
			phoneNumber: combinedPhoneNumber, // Use the combined phone number
			captchaToken: captchaToken
		};

		// Validate form data using Zod schema
		const validationResult = UserValidationSchema.safeParse(dataToSend);

		// Initialize an object to store error messages
		let errors = {};

		// If validation fails, store the errors
		if (!validationResult.success) {
			validationResult.error.errors.forEach((err) => {
				errors[err.path[0]] = err.message; // Set the error message for the specific field
			});
			if (!isChecked) {
				errors["termsAccepted"] =
					"You must accept the terms and privacy policy.";
			}

			// Update the inputErrors state with the validation errors
			setInputErrors(errors);

			setIsLoading(false); // Stop loading
			return; // Prevent request from being sent
		}
		const requestHandler2 = async (api, setLoading, onSuccess, onError) => {
			// Show loading state if setLoading function is provided
			if (setLoading) setLoading(true);
			try {
				// Make the API request
				const response = await api();
				const { data } = response;
				if (data?.statusCode < 400) {
					// Call the onSuccess callback with the response data
					onSuccess(data);
				}
			} catch (error) {
				// Handle error cases, including unauthorized and forbidden cases
				if ([403].includes(error?.response?.data?.statusCode)) {
					localStorage.clear(); // Clear local storage on authentication issues
					window.location.href = "/"; // Redirect to login page
				}
				// for Input Type validation errors
				if (409 === error?.response?.data?.statusCode) {
					const keys = Object.keys(error?.response?.data?.error);
					const errorArray = error?.response?.data?.error[keys[0]];
					for (let i = 0; i < keys.length; i++) {
						setInputErrors({ [keys[i]]: errorArray[i] });
					}

					onError(
						errorArray[0] ||
							error?.response?.data?.message ||
							"Something went wrong",
					);
				} else {
					onError(error?.response?.data?.message || "Something went wrong");
				}
			} finally {
				// Hide loading state if setLoading function is provided
				if (setLoading) setLoading(false);
			}
		};

		requestHandler2(
			async () => await apiClient.post(`${baseUrl}/user/register`, dataToSend),
			setIsLoading,
			(res) => {
				setIsRegistering(false);
				toast.success("Otp send to your email!");
				setResendCountdown(60);
				setInputErrors({});
			},
			(e) => {
				console.log(e);
				toast.error(e);
			},
		);
	};

	const handleResendOtp = async () => {
		setIsLoading(true);

		try {
			await apiClient.post(`${baseUrl}/auth/resendOtp`, {
				email: formData.email,
			});
			toast.success("OTP resent successfully!");
			setResendCountdown(60);
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Failed to resend OTP. Please try again.";
			console.error(errorMessage);
			toast.error(errorMessage);
		} finally {
			setIsLoading(false);
		}
	};

	const handleOtpSubmit = async (e) => {
		e.preventDefault();
		setIsLoading(true);

		try {
			let response;
			if (token) {
				response = await apiClient.post(`${baseUrl}/auth/verifyOtpInvite`, {
					email: formData.email,
					otp,
					token,
				});
			} else {
				response = await apiClient.post(`${baseUrl}/auth/verifyOtp`, {
					email: formData.email,
					otp,
				});
			}
			console.log(response.data);
			// Handle success response
			setVerified(true);
			toast.success("Otp verified! Registration Successful!");
			setTimeout(() => {
				router("/");
			}, 3000);
		} catch (error) {
			console.error(error);
			toast.error("Wrong Otp!");
			// Handle error response
		} finally {
			setIsLoading(false);
		}
	};

	const handleSearchChange = (event) => {
		setSearchTerm(event.target.value);
	};

	const filteredCountries = countries.filter((country) =>
		country.name.toLowerCase().includes(searchTerm.toLowerCase()),
	);

	const handleCountrySelect = (country) => {
		setSelectedCountry(country);
		setCountryCode(country.code);
		setSearchTerm(""); // Clear search term on selection
		setIsDropdownOpen(false); // Close the dropdown
	};

	const handleClearSelection = () => {
		setSelectedCountry(null); // Clear the selected country
		setCountryCode("");
		setPhoneNumber("");
		setSearchTerm(""); // Clear the search term
	};

	const openModal = (type) => {
		if (type === "privacy") {
			setModalContent("privacy");
		} else if (type === "terms") {
			setModalContent("terms");
		}
		console.log(type);
		setIsModalOpen(true);
	};

	const closeModal = () => {
		setIsModalOpen(false);
		setModalContent("");
	};

	return (
		<SlimLayout>
			{isLoading && <LoadingSpinner />}
			<div className="flex">
				<Link href="/" aria-label="Home">
					<img src={onelyk} alt="Home" className="h-9 w-auto sm:h-10 md:h-12" />
				</Link>
			</div>
			{isRegistering ? (
				<>
					<h2 className="mt-4 sm:mt-5 text-base sm:text-lg font-semibold text-gray-900">
						Get started for free
					</h2>
					<p className="mt-2 text-xs sm:text-sm text-gray-700">
						Already registered?{" "}
						<a href="/" className="font-medium text-blue-600 hover:underline">
							Sign in
						</a>{" "}
						to your account.
					</p>
					<form
						onSubmit={handleRegisterSubmit}
						className="mt-6 sm:mt-8 md:mt-10 grid grid-cols-1 gap-x-4 sm:gap-x-6 gap-y-6 sm:gap-y-8 sm:grid-cols-2"
					>
						<div>
							<TextField
								label="First name"
								name="firstName"
								type="text"
								autoComplete="given-name"
								required
								onChange={handleChange}
								value={formData.firstName}
							/>
							<div className="text-red-500 text-xs">
								{inputErrors.firstName && <span>{inputErrors.firstName}</span>}
							</div>
						</div>

						<div>
							<TextField
								label="Last name"
								name="lastName"
								type="text"
								autoComplete="family-name"
								required
								onChange={handleChange}
								value={formData.lastName}
							/>
							<div className="text-red-500 text-xs">
								{inputErrors.lastName && <span>{inputErrors.lastName}</span>}
							</div>
						</div>
						<div className="col-span-full">
							<div className="relative left-[164px] top-[19px]">
								<div className="flex items-center gap-1 group">
									<InformationCircleIcon className="h-4 w-4 text-gray-400 group-hover:text-indigo-600 cursor-pointer" />

									{/* Tooltip */}
									<div
										className="absolute left-0 top-6 hidden group-hover:block
            bg-black text-white text-xs px-2 py-1 rounded shadow-md w-max"
									>
										This signup is for individual users, not businesses
									</div>
								</div>
							</div>
							<TextField
								className="col-span-full"
								label="Personal Email address"
								name="email"
								type="email"
								autoComplete="email"
								required
								onChange={handleChange}
								value={formData.email}
							/>

							<div className="text-red-500 text-xs">
								{inputErrors.email && <span>{inputErrors.email}</span>}
							</div>
						</div>

						{/* Country Code and Phone Number Fields */}

						<div className="col-span-full">
							<label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
								Phone Number
							</label>
							<div className="relative">
								<div className="flex">
									<div className="relative w-[100px] sm:w-[120px] flex-shrink-0">
										<button
											type="button"
											onClick={toggleDropdown}
											className="w-full h-full flex items-center justify-between px-2 sm:px-3 py-2 border border-gray-300 bg-white rounded-l-md text-xs sm:text-sm hover:bg-gray-50 transition-colors"
										>
											<span className="flex items-center gap-1 sm:gap-2 truncate">
												{selectedCountry ? (
													<>
														<span className="text-base sm:text-lg">
															{selectedCountry.flag}
														</span>
														<span className="truncate">
															{selectedCountry.code}
														</span>
													</>
												) : (
													"+1"
												)}
											</span>
											<svg
												className={`w-3 h-3 sm:w-4 sm:h-4 text-gray-400 transition-transform duration-200 flex-shrink-0 ${
													isDropdownOpen ? "rotate-180" : ""
												}`}
												viewBox="0 0 20 20"
												fill="currentColor"
											>
												<path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
											</svg>
										</button>
									</div>
									<input
										type="tel"
										value={phoneNumber}
										onChange={(e) => setPhoneNumber(e.target.value)}
										placeholder="Enter phone number"
										className="flex-1 rounded-r-md border border-l-0 border-gray-300 
                       px-3 py-2 text-xs sm:text-sm text-gray-700 
                       focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                       placeholder:text-gray-400"
									/>
								</div>

								{/* Dropdown */}
								{isDropdownOpen && (
									<div
										ref={dropdownRef}
										className="absolute top-full left-0 mt-1 w-full sm:w-64 bg-white border border-gray-200 rounded-md shadow-lg z-50"
									>
										<div className="p-2">
											<input
												ref={searchInputRef}
												type="text"
												value={searchTerm}
												onChange={(e) => setSearchTerm(e.target.value)}
												placeholder="Search country..."
												className="w-full px-3 py-2 border border-gray-300 rounded-md text-xs sm:text-sm
                           focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                           placeholder:text-gray-400"
											/>
										</div>
										<div className="max-h-48 sm:max-h-60 overflow-y-auto">
											{filteredCountries.map((country) => (
												<div
													key={country.code}
													className="px-3 sm:px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2 sm:gap-3 text-xs sm:text-sm"
													onClick={() => handleCountrySelect(country)}
												>
													<span className="text-base sm:text-lg">
														{country.flag}
													</span>
													<span className="text-gray-700 flex-1 truncate">
														{country.name}
													</span>
													<span className="text-gray-500 flex-shrink-0">
														{country.code}
													</span>
												</div>
											))}
											{filteredCountries.length === 0 && (
												<div className="px-3 sm:px-4 py-2 text-xs sm:text-sm text-gray-500">
													No countries found
												</div>
											)}
										</div>
									</div>
								)}
							</div>
							<div className="text-red-500 text-xs mt-1">
								{inputErrors.phoneNumber && (
									<span>{inputErrors.phoneNumber}</span>
								)}
							</div>
						</div>

						<div className="col-span-full">
							<div className="relative col-span-full">
								<TextField
									label="Password"
									name="password"
									type={showPassword ? "text" : "password"}
									autoComplete="new-password"
									required
									onChange={handleChange}
									value={formData.password}
								/>
								<button
									type="button"
									className="absolute right-0 top-8 sm:top-10 flex items-center pr-3 text-sm"
									onClick={() => setShowPassword(!showPassword)}
									aria-label={showPassword ? "Hide password" : "Show password"}
								>
									{showPassword ? (
										<FaEyeSlash className="h-4 w-4 sm:h-5 sm:w-5 text-gray-500" />
									) : (
										<FaEye className="h-4 w-4 sm:h-5 sm:w-5 text-gray-500" />
									)}
								</button>
							</div>
							<div className="text-red-500 text-xs mt-1">
								{inputErrors.password && <span>{inputErrors.password}</span>}
							</div>
						</div>
						<div className="col-span-full">
							<SelectField
								className="col-span-full"
								label="How did you hear about us?"
								name="referralSource"
								required
								onChange={handleChange}
								value={formData.referralSource}
							>
								<option value="" disabled>
									Select an option
								</option>
								<option value="facebook">Facebook</option>
								<option value="twitter">Twitter</option>
								<option value="advertisement">Advertisement</option>
								<option value="other">Other</option>
							</SelectField>
							<div className="text-red-500 text-xs">
								{inputErrors.referralSource && (
									<span>{inputErrors.referralSource}</span>
								)}
							</div>
						</div>
						<div className="col-span-full">
							<label className="flex items-start gap-2 text-xs sm:text-sm">
								<input
									type="checkbox"
									checked={isChecked}
									onChange={(e) => setIsChecked(e.target.checked)}
									required
									className="mt-0.5 sm:mt-1 h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0"
								/>
								<span className="leading-tight">
									I agree to the{" "}
									<button
										type="button"
										onClick={() => openModal("terms")}
										className="text-blue-500 underline hover:text-blue-700"
									>
										Terms and Conditions
									</button>{" "}
									and{" "}
									<button
										type="button"
										onClick={() => openModal("privacy")}
										className="text-blue-500 underline hover:text-blue-700"
									>
										Privacy Policy
									</button>
								</span>
							</label>
							<div className="text-red-500 text-xs mt-1">
								{inputErrors.termsAccepted && (
									<span>{inputErrors.termsAccepted}</span>
								)}
							</div>
						</div>
						<div className="col-span-full flex flex-col items-center justify-center">
						<ReCaptchaField
  onVerify={(token) => {
    setCaptchaToken(token);

    if (token) {
      setInputErrors((prev) => ({
        ...prev,
        captcha: null,
      }));
    }
  }}
/>
<div className="text-red-500 text-xs text-center mt-1">
								{inputErrors.captcha && <span>{inputErrors.captcha}</span>}
							</div>

</div>

						<div className="col-span-full">
							<Button
								type="submit"
								variant="solid"
								color="blue"
								className="w-full text-sm sm:text-base"
							>
								<span>
									Sign up <span aria-hidden="true">&rarr;</span>
								</span>
							</Button>
						</div>
					</form>
				</>
			) : (
				<>
					{!verified ? (
						<form
							onSubmit={handleOtpSubmit}
							className="mt-4 sm:mt-6 md:mt-8 grid grid-cols-1 gap-x-4 sm:gap-x-6 gap-y-6 sm:gap-y-8 sm:grid-cols-2"
						>
							<div className="col-span-full sm:col-span-1">
								<h2 className="mt-8 sm:mt-12 md:mt-20 text-base sm:text-lg font-semibold text-gray-900">
									Verify your email
								</h2>
								<p className="mt-2 text-xs sm:text-sm text-gray-700">
									Enter the OTP sent to your email.
								</p>
							</div>
							<TextField
								className="col-span-full sm:col-span-1"
								label="OTP"
								name="otp"
								type="text"
								required
								onChange={handleOtpChange}
								value={otp}
							/>
							<div className="col-span-full flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 sm:gap-4">
								<Button
									type="submit"
									variant="solid"
									color="blue"
									className="w-full sm:w-auto text-sm sm:text-base"
								>
									<span>
										Verify <span aria-hidden="true">&rarr;</span>
									</span>
								</Button>
								<Button
									type="button"
									variant="outline"
									color="gray"
									className="w-full sm:w-auto sm:ml-4 text-sm sm:text-base"
									onClick={handleResendOtp}
									disabled={resendCountdown > 0}
								>
									{resendCountdown > 0
										? `Resend OTP (${resendCountdown})`
										: "Resend OTP"}
								</Button>
							</div>
						</form>
					) : (
						<div className="mt-8 sm:mt-10 text-center">
							<h3 className="text-base sm:text-lg font-semibold text-green-600">
								Email verified successfully!
							</h3>
							<p className="mt-2 text-xs sm:text-sm text-gray-700">
								Your email has been verified. Redirecting to login page...
							</p>
						</div>
					)}
				</>
			)}
			<ConditionsModal
				isOpen={isModalOpen}
				onClose={closeModal}
				type={modalContent}
			/>
		</SlimLayout>
	);
}
